import axios from "axios";
import fileDownload from 'js-file-download';

const FILE_NAME = 'file'
const DATEI_UPLOAD_ROUTE = '/v1/projekt/create';
const FILES_NAME = 'files'
const DATEIEN_UPLOAD_ROUTE = '/v1/projekt/create';

export default {
    methods: {
        dateiUpload(dateien, callback) {
            if (dateien.some(el => el.type === "application/vnd.ms-excel" || el.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")) {
                if (dateien) {
                    if (dateien.length <= 1) {
                        this._callDateiUpload(dateien, callback);
                    } else {
                        this._callDateienUpload(dateien, callback);
                    }
                } else {
                    callback();
                }
            }
            else {
                console.log('Falscher Datentyp');
                // this.showErrorSnackbarWithMessage('Upload dieses Datentyps nicht möglich!');
            }
        },
        dateiUploadPdf(dateien, callback) {
            if (dateien.some(el => el.type === "application/pdf")) {
                this.dateiUpload(dateien, callback)
            }
            else {
                // this.showErrorSnackbarWithMessage('Upload dieses Datentyps nicht möglich!');
            }
        },
        dateiDownload(uuid, label) {

            axios.get(this._getDownloadRoute(uuid), { responseType: 'blob' })
                .then((response) => fileDownload(response.data, `${label}`))
                .catch(() => this.showErrorSnackbarWithMessage('Download nicht möglich!'));
        },
        getDateiUploadArray(dateiUploadResponse) {
            let dateienUpload = [];
            if (dateiUploadResponse !== undefined) {
                if (Array.isArray(dateiUploadResponse.data)) {
                    dateienUpload = dateiUploadResponse.data;
                } else {
                    dateienUpload.push(dateiUploadResponse.data);
                }
            }
            return dateienUpload;
        },
        _callDateiUpload(dateien, callback) {
            const formData = this._getFormData(dateien, FILE_NAME);
            this._postDateien(DATEI_UPLOAD_ROUTE, formData, callback);
        },
        _callDateienUpload(dateien, callback) {
            const formData = this._getFormData(dateien, FILES_NAME);
            this._postDateien(DATEIEN_UPLOAD_ROUTE, formData, callback);
        },
        _getFormData(dateien, name) {
            let formData = new FormData();
            for (let i = 0; i < dateien.length; i++) {
                formData.append(name, dateien[i]);
            }
            return formData;
        },
        _postDateien(route, formData, callback) {
            axios.post(route, formData, {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
            })
              .then(response => {
                callback(response);
              })
              .catch((error) => {
                callback(error.response);
                // this.showErrorSnackbarWithMessage('Upload der Dateien nicht möglich!');
              });
        },
        _getDownloadRoute(uuid) {
            return `/v1/dateien/${uuid}/laden`;
        },
    }
}

